import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbSpinnerService } from '@nebular/theme';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { general } from 'src/app/models/general';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-solicitudes-servicios',
  templateUrl: './solicitudes-servicios.component.html',
  styleUrls: ['./solicitudes-servicios.component.css']
})
export class SolicitudesServiciosComponent implements OnInit {
  public servicios
  public poraportes
  public modelo: any
  private identity: any
  public tipocampo: any
  constructor(private _userService: UserService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private router: Router) {
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'))
    this.poraportes = [
      { codservicio: 3, servicio: '3%' },
      { codservicio: 4, servicio: '4%' },
      { codservicio: 5, servicio: '5%' },
      { codservicio: 6, servicio: '6%' },
      { codservicio: 7, servicio: '7%' },
      { codservicio: 8, servicio: '8%' },
      { codservicio: 9, servicio: '9%' },
      { codservicio: 10, servicio: '10%' }
    ]

    this.modelo = new general();
  }

  ngOnInit(): void {
    this.spinner.show()
    this.getServicios()
  }

  getServicios() {
    console.log('tipo_servicios')
    this._userService.httpGet('getServiciosFonebaker').subscribe(resp => {
      this.servicios = resp.details
      this.spinner.hide()
    })
  }

  cambiacampo(event) {
    console.log(event)
    this.tipocampo = ''
    for (let i = 0; i < this.servicios.length; i++) {
      if (this.servicios[i].codservicio == event) {
        this.tipocampo = this.servicios[i].campo
      }
    }
  }

  submit() {
    this.spinner.show()
    for (let i = 0; i < this.servicios.length; i++) {
      if (this.servicios[i].codservicio == this.modelo.servicio) {
        this.modelo.linea = this.servicios[i].servicio
      }
    }
    this.modelo.codasociado = this.identity.CODASOCIADO
    console.log(this.modelo)
    this._userService.httpPost('sol_servicios_f', this.modelo).subscribe(resp => {
      Swal.fire({
        icon: resp.status,
        text: resp.message
      })
      this.spinner.hide()
      //this.messageService.add({ severity: resp.status, detail: resp.message });
      if (resp.status == 'success') {
        this.router.navigate(['/home'])
      }
    })
  }

}
